import { useState as i, useRef as m, useEffect as f } from "react";
const p = (e, o = 500, r = 250, c = 250) => {
  const [s, t] = i(r === 0), n = m(0);
  return f(() => {
    const u = setTimeout(() => {
      e || (t(!0), n.current = performance.now());
    }, r);
    return () => clearTimeout(u);
  }, [r, e]), f(() => {
    if (e !== !0)
      return;
    if (!n.current || performance.now() - n.current < c) {
      t(!1);
      return;
    }
    const u = setTimeout(() => {
      t(!1);
    }, o);
    return () => clearTimeout(u);
  }, [e, o, c]), e !== !0 || s;
};
export {
  p as useShouldRenderLoading
};
